// extracted by mini-css-extract-plugin
export var text = "facebook-banner-module--text--fc8cf";
export var wrapper = "facebook-banner-module--wrapper--cb8fb";